import {
    IonContent, IonHeader, IonInput, IonPage, IonTitle, IonToolbar, useIonViewWillEnter,
} from '@ionic/react';
import './Blindbox.css';
import React, {useState,} from "react";
import ReactCardFlip from 'react-card-flip';
import {getBlindBoxInfoByNumber, receiveByUserInfo} from "./Service";
import {getQueryVariable, decrypt} from "../../utils/commonFunction"
// @ts-ignore
import { Helmet } from 'react-helmet';

class BlindBoxInfo {
    sysId = 0;
    boxNumber = '';
    boxType = 0;
    batchNo = 0;
    prizeId = 0;
    prizeName = '';
    prizeCount = 0;
    prizeImageUrl = '';
    receiveDate = '';
}

const BoxPrize: React.FC = () => {
    const [showRule, setShowRule] = useState<boolean>(false);
    const [showGreybackground, setShowGreybackground] = useState<boolean>(false);
    const [showReceivePage, setShowReceivePage] = useState<boolean>(false);
    const [showReceived, setShowReceived] = useState<boolean>(false);
    const [isFlipped, setIsFlipped] = useState<boolean>(false);
    const [username, setUsername] = useState<string>('');
    const [phone, setPhone] = useState<string>('');
    const [gameAccount, setGameAccount] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [phoneTip, setPhoneTip] = useState<number>(0);
    const [boxNumber, setBoxNumber] = useState<string>('');
    const [receiveDate, setReceiveDate] = useState<string>('');
    const [blindBoxInfo, setBlindBoxInfo] = useState<BlindBoxInfo>({
        sysId: 0,
        boxNumber: '',
        boxType: 0,
        batchNo: 0,
        prizeId: 0,
        prizeName: '',
        prizeCount: 0,
        prizeImageUrl: '',
        receiveDate: '',
    });
    const handleClick = () => {
        setIsFlipped(!isFlipped);
    };

    const openRule = () => {
        setShowRule(true)
        setShowGreybackground(true)
    }

    const toReceivePrize = () => {
        setShowGreybackground(true)
        setShowReceivePage(true)
    }

    const subMessage = () => {
        if (phoneTip === 1) {
            return;
        }
        if (gameAccount.length === 0) {
            alert("游戏账号不能为空")
            return;
        }
        const params = {
            phone: phone,
            username: username,
            address: address,
            gameAccount: gameAccount,
            boxNumber: decrypt(boxNumber)
        }
        receiveByUserInfo(params).then(ret => {
            if (ret.result == 10000) {
                setReceiveDate(ret.data)
                //setShowGreybackground(true)
                setShowReceivePage(false)
                setShowReceived(true)
            } else {
                alert(ret.msg);
            }
        }).catch(err => {
            console.log(err);
            alert("领奖失败，请稍后再试或联系我们。");
        });


    }

    const closePage = () => {
        setShowGreybackground(false)
        setShowReceived(false)
        setShowReceivePage(false)
        setShowRule(false)
    }

    const closeRule = () => {
        setShowGreybackground(false)
        setShowRule(false)
    }

    useIonViewWillEnter(() => {
        const boxNum = getQueryVariable("boxNum");
        if (boxNum && boxNum.length > 0) {
            setBoxNumber(boxNum);
            const params = {
                boxNumber: decrypt(boxNum)
            }
            getBlindBoxInfoByNumber(params).then(ret => {
                if (ret.result == 10000) {
                    setBlindBoxInfo(ret.data)
                    if (ret.data.receiveDate) {
                        setReceiveDate(ret.data.receiveDate)
                        setShowReceived(true)
                    }
                }
            }).catch(err => {
                console.log(err);
                // alert("查询失败，请稍后再试或联系我们。");
            });
        }


    });

    const regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)

    const checkPhone = () => {
        if (phone.length !== 0 && !regPhone.test(phone)) {
            setPhoneTip(1)
        } else setPhoneTip(0)
    };
    const setPhoneNo = (e: any) => {
        setPhone(e);
    }

    const setInputUserName = (e: any) => {
        setUsername(e);
    }
    const setInputAddress = (e: any) => {
        setAddress(e);
    }
    const setInputGameAccount = (e: any) => {
        setGameAccount(e);
    }

    return (
        <IonPage placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <IonHeader placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div>
                    <Helmet placeholder={""}>
                        <title>惊喜无限！精彩盲盒活动开启！</title>
                    </Helmet>
                    <meta name="viewport" content="width=750,target-densitydpi=device-dpi"/>
                    <meta content="telephone=no" name="format-detection"/>
                </div>
            </IonHeader>

            <IonContent fullscreen placeholder={undefined} onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}>
                <div className="bb_index pr">
                    <a onClick={openRule} className="bb_rules"></a>
                    <div className="bb_bg">
                        <div className={showReceived ? "dn" : 'bb_cont'}>
                            <div className="bb_prize_cont">
                                <h1 className="bb_title">点击翻牌 领取奖励</h1>
                                <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
                                    <div className="card" onClick={handleClick}>
                                        {/*<img src="back.png" alt="back" />*/}
                                    </div>

                                    {blindBoxInfo.prizeId > 0 ? <div className={isFlipped ?"card-flip":"dn" }>
                                        <div className="bb_prize_img">
                                            <img src={blindBoxInfo.prizeImageUrl}/>
                                        </div>
                                        <p>{blindBoxInfo.prizeName + "x" + blindBoxInfo.prizeCount}</p>
                                    </div> : <div className={isFlipped ?"":"dn" }>
                                        <h1 className="bb_title">谢谢参与<br/>很遗憾未中奖,下次加油哦！</h1>
                                        <div className="card-flip2">
                                            <div className="prize_img"><img
                                                src={require("../images/blindbox/wzj_img.png")}/></div>
                                        </div>
                                    </div>}
                                </ReactCardFlip>
                                {blindBoxInfo.prizeId > 0 && isFlipped ? <div onClick={toReceivePrize} className="lq_btn"><img
                                        src={require("../images/blindbox/lq_btn.png")}/></div> : ""}

                            </div>
                        </div>

                        {/* <!--活动弹窗部分-->*/}
                        {/*<!-------------------------灰色透明层--------------------->*/}
                        <div className={showGreybackground ? "greybackground_box" : "dn"}></div>
                        {/*<!-------------------------活动规则弹窗-------------------->*/}
                        <div className={showRule ? "tc02_box tc_rule" : "dn"}>
                            <div className="tc_bg_box">
                                <a className="close" onClick={closeRule}>关闭</a>
                                <div className="tc_cont_box">
                                    <div className="tc_title_box">活动规则</div>
                                    <div className="tc_tex_box">
                                        <p className="rule_text"><span>1</span>获得盲盒以后，扫码底座的二维码，输入对应的编号，即可获得随机大奖。</p>
                                        <p className="rule_text"><span>2</span>扫码获得的礼品奖励，完成线上线下信息填写（仅用于身份确认）。</p>
                                        <p className="rule_text"><span>3</span>获得奖励以后，7个工作日内进行奖励发放。</p>
                                        <p className="rule_text"><span>4</span>如中奖用户不同意填写个人信息，或不同意当面领取实物奖品，或超过中奖时间30天未联系，则视为弃奖。
                                        </p>
                                    </div>
                                    <div className="tc_tex_box">
                                        <p className="tc_tex_title rule_text">活动专属时间：</p>
                                        <p className="rule_text" >2023年7月3号-2024年7月3号 </p>
                                    </div>
                                    <div className="tc_tex_box">
                                        <p className="tc_tex_title rule_text">扫码有效时间： </p>
                                        <p className="rule_text">自中奖日期开始30天内可以进行兑换</p>
                                    </div>
                                    <div className="tc_tex_box">
                                        <p className="tc_tex_title rule_text">须知：</p>
                                        <p className="rule_text">该页面存在缓存，如您实际中奖内容与活动规则不一致，请清除手机缓存并刷新页面。 </p>
                                    </div>
                                    <div className="tc_tex_box">
                                        <p className="tc_tex_title rule_text">活动主办方：杭州浮云网络科技有限公司</p>
                                        <p className="rule_text">活动咨询电话：400-885-2091</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<!-------------------------领取奖励弹窗-------------------->*/}
                        <div className={showReceivePage ? "tc02_box" : "dn"}>
                            <div className="tc_bg_box">
                                <a className="close" onClick={closePage}>关闭</a>
                                <div className="tc_cont_box">
                                    <div className="tc_title_box rule_text">领取奖励</div>
                                    <div className="tc_tex">
                                        <p className="rule_text">为了奖品准确的发放,请您填写准确的收货地址信息</p>
                                        {/*<p className="textorange rule_text">填写时间:7月3日-9月3日</p>*/}
                                    </div>
                                    <div className="input-cont">
                                        <div className="msg-input clearfix">
                                            <span>姓名(选填)</span>
                                            <IonInput type="text" className="span_input" value={username}
                                                      placeholder="请填写真实姓名"
                                                      onIonChange={e => setInputUserName(e.detail.value)}
                                                      onPointerEnterCapture={undefined}
                                                      onPointerLeaveCapture={undefined}/>
                                        </div>
                                        <div className="msg-input clearfix">
                                            <span>电话(选填)</span>
                                            <IonInput type="text" maxlength={11} minlength={11} className="span_input"
                                                      value={phone} placeholder="请填写您的电话"
                                                      onIonChange={e => setPhoneNo(e.detail.value)}
                                                      onIonBlur={e => checkPhone()} onPointerEnterCapture={undefined}
                                                      onPointerLeaveCapture={undefined}/>

                                        </div>
                                        {/*<!------------电话号码输入错误提示----------------->*/}
                                        <p id="phonenumber_ico_err"
                                           className={phoneTip === 1 ? "error-icon02" : "dn"}>号码格式错误</p>
                                        <div className="msg-input clearfix">
                                            <span>游戏账号</span>
                                            <IonInput type="text" className="span_input" value={gameAccount}
                                                      onIonChange={e => setInputGameAccount(e.detail.value)}
                                                      placeholder="请填写您的游戏账号" onPointerEnterCapture={undefined}
                                                      onPointerLeaveCapture={undefined}/>
                                        </div>
                                        <div className="msg-input clearfix">
                                            <span>收货地址</span>
                                            <IonInput type="text" className="span_input" value={address}
                                                      onIonChange={e => setInputAddress(e.detail.value)}
                                                      placeholder="请填写您的收货地址" onPointerEnterCapture={undefined}
                                                      onPointerLeaveCapture={undefined}/>
                                        </div>
                                        <a onClick={subMessage} className="tj_btn"><img
                                            src={require("../images/blindbox/tj_btn.png")}/></a>
                                    </div>
                                    <div className="tc_tex">
                                        <p className="textGrey6 rule_text">1.以上信息浮云科技仅用作发放活动奖品使用</p>
                                        <p className="textGrey6 rule_text">2.若获得的奖励为实物，请详细填写姓名、电话和详细的收货地址</p>
                                        <p className="textorange tac rule_text">*中奖用户若因自己填写信息不实，无法收到奖品<br/>将视为自动放弃奖品
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/*<!-------------------------核销弹窗-------------------->*/}
                        <div className={showReceived ? "tc02_box" : "dn"}>
                            <div className="tc_bg_box">
                                {/*<a className="close" onClick={closePage}>关闭</a>*/}
                                <div className="hx_tex">
                                    <p className="hx_tex01">中奖状态</p>
                                    <p className="hx_tex02">已中奖</p>
                                </div>
                                <div className="hx_bg">
                                    <p className="hx_tex01">中奖内容</p>
                                    <p className="hx_tex02">获得{blindBoxInfo.prizeName + "x" + blindBoxInfo.prizeCount}</p>
                                </div>
                                <div className="hx_tex">
                                    <p className="hx_tex01">领取时间</p>
                                    <p className="hx_tex03">{receiveDate}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );

};

export default BoxPrize;


